module.exports = __webpack_public_path__ + "static/media/Washington_DC_Image_-_rounded_corners.37c5c661.png";